import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames/dedupe'

import './Button.less'

export default class Button extends React.Component {
  render () {
    const handleClick = typeof this.props.onClick === 'function' &&
      !this.props.disabled
      ? this.props.onClick
      : () => {} // no-op
    const headerClass = classNames(
      this.props.className,
      'nmc-button',
      this.props.disabled ? 'is-disabled' : []
    )
    return (
      <div>
        <button className={headerClass} onClick={handleClick}>
          {this.props.children}
        </button>
        {
          this.props.tooltip
            ? <span className={'nmc-button-tooltip'}>{this.props.tooltip}</span>
            : null
        }
      </div>
    )
  }
}

Button.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Button/index.js